import { render } from "./ShadowControl.vue?vue&type=template&id=23b89d0f&scoped=true"
import script from "./ShadowControl.vue?vue&type=script&lang=js"
export * from "./ShadowControl.vue?vue&type=script&lang=js"

import "./ShadowControl.vue?vue&type=style&index=0&id=23b89d0f&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b89d0f"]])

export default __exports__